import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils';

// Async thunks
export const fetchProductsRagnarok = createAsyncThunk(
    'projects/fetchProjects',
    async () => {
        const response = await apiFetch(`api/products/type/2`);
        const data = await response.json();
        return data;
    }
);

export const fetchConfigRagnarok = createAsyncThunk(
    'config/fetch',
    async (projectId) => {
        const res = await apiFetch(`/api/project/config/${projectId}`);
        if (!res.ok) throw new Error("Failed to fetch configs");
        return await res.json();
    }
);

export const saveConfigRagnarok = createAsyncThunk(
    'config/save',
    async (payload) => {
        const res = await apiFetch(`/api/project/config`, {
            method: "POST",
            body: JSON.stringify(payload),
            idempotencyAction: "config:save"
        });
        return await res.json();
    }
);

const ragnarokSlice = createSlice({
    name: 'ragnarok',
    initialState: {
        products: [],
        loading: false,
        error: null,
        originalConfigFiles: [],
        newConfigFiles: [],
        showModal: false
    },
    reducers: {
        handleEntryChange(state, action) {
            const { fileName, entryName, field, value } = action.payload;
            state.newConfigFiles = state.newConfigFiles.map(file => {
                if (file.name !== fileName) return file;

                return {
                    ...file,
                    entries: file.entries.map(entry =>
                        entry.keyName === entryName
                            ? { ...entry, [field]: value }
                            : entry
                    )
                };
            });
        },
        showDiffModal(state, action) {
            state.showModal = action.payload != null ? action.payload : !state.showModal;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch projects
            .addCase(fetchProductsRagnarok.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductsRagnarok.fulfilled, (state, action) => {
                state.products = action.payload;
                state.loading = false;
            })
            .addCase(fetchProductsRagnarok.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchConfigRagnarok.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchConfigRagnarok.fulfilled, (state, action) => {
                state.originalConfigFiles = action.payload;
                state.newConfigFiles = action.payload;
                state.loading = false;
            })
            .addCase(fetchConfigRagnarok.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(saveConfigRagnarok.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(saveConfigRagnarok.fulfilled, (state, action) => {
                if (action.payload?.success === true) {
                    state.originalConfigFiles = state.newConfigFiles;
                    alert("Config Saved");
                }
                state.showModal = false;
                state.loading = false;
            })
            .addCase(saveConfigRagnarok.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { handleEntryChange, showDiffModal } = ragnarokSlice.actions;
export default ragnarokSlice.reducer;
